<template>
  <div>
	  <Slide :closeOnNavigation="true" right>
		  <a href="#services">
			  <span>Services</span>
		  </a>
		  <a href="#work">
			  <span>Work</span>
		  </a>
		  <a href="#values">
			  <span>Values</span>
		  </a>
	  </Slide>  
	  <div class="hero-section">
		  <h1>The Next Episode Is Here <span class="horizontal-redline"></span></h1>
		  <p>Not just designers, coders or marketers; we are all of them, rolled into one. We'll help you capture your brand's full potential and <i>engineer</i> your revenue growth. </p>
		  <a class="cta" href="https://super-awesome-lab.typeform.com/to/PK98i81C">Let's Talk</a>
		  <div id="video-element" 
			   style='background-image: url("/images/header-image.png");' class="center-visual drop-shadow">
			  <video id="rocket-video" src="/videos/rocket-launch_2.mp4"  muted></video>
	      </div> 
		  <kinesis-container
            event="scroll" class="glowing-circle-parent">
			  <kinesis-element 
							   tag="img"
							   class="glowing-circle"
							   :strength="500"
							   type="translate"
							    axis="y"
							    src="/images/glowing-circle.svg"
							   />
		  </kinesis-container>
	  </div>
	  <div id="services" class="marketing-strategy">
		  <h2  data-aos="fade-up"
		   offset="120"
		   data-aos-delay="50"
		   data-aos-duration="500"
		   data-aos-easing="ease"
		   data-aos-mirror="false"
		   data-aos-once="true"
		   data-aos-anchor-placement="top-bottom" >
			  Marketing Strategy
		  </h2>
		  <div data-aos="fade-up"
		   offset="120"
		   data-aos-delay="50"
		   data-aos-duration="500"
		   data-aos-easing="ease"
		   data-aos-mirror="false"
		   data-aos-once="true"
		   data-aos-anchor-placement="top-bottom" class="side-bar-p">
			  <div class="red-bar">
			  </div>
			  <p>
				  Let us take the DNA of your business and synthesis it into a simple lean canvas. With it you can visualize all the moving parts of your business and plan better. We can help you:
			  </p>
		  </div>
		  <div data-aos="fade-up"
		   offset="120"
		   data-aos-delay="50"
		   data-aos-duration="500"
		   data-aos-easing="ease"
		   data-aos-mirror="false"
		   data-aos-once="true"
		   data-aos-anchor-placement="top-bottom"  class="details-section">
			  <img src="/images/understand.svg">
			  <h3>Understand</h3>
			  <p>Study the lay of the land and the workings of your market. </p>
		  </div>
		  <div data-aos="fade-up"
		   offset="120"
		   data-aos-delay="50"
		   data-aos-duration="500"
		   data-aos-easing="ease"
		   data-aos-mirror="false"
		   data-aos-once="true"
		   data-aos-anchor-placement="top-bottom" class="details-section">
			  <img src="/images/analyze.svg">
			  <h3>Analyze</h3>
			  <p>Uncover your true value proposition and your competitive advantage.</p>
		  </div>
		  <div data-aos="fade-up"
		   offset="120"
		   data-aos-delay="50"
		   data-aos-duration="500"
		   data-aos-easing="ease"
		   data-aos-mirror="false"
		   data-aos-once="true"
		   data-aos-anchor-placement="top-bottom" class="details-section">
			  <img src="/images/position.svg">
			  <h3>Position</h3>
			  <p>Meet your customers with the right message, at the right time and place.</p>
		  </div>
		  <kinesis-container
            event="move" class="center-visual background-frame drop-shadow">
			  <kinesis-element 
							   tag="img"
							   :strength="20"
							   type="depth"
							   src="/images/strategy.svg"
							   />
		  </kinesis-container>
		  <kinesis-container
            event="scroll" class="glowing-circle-parent">
			  <kinesis-element 
							   tag="img"
							   class="glowing-circle"
							   :strength="500"
							   type="translate"
							    axis="y"
							    src="/images/glowing-circle.svg"
							   />
		  </kinesis-container>
	</div>	
	<div class="landing-page">
		<h2 data-aos="fade-left"
		 offset="120"
		 data-aos-delay="50"
		 data-aos-duration="800"
		 data-aos-easing="ease"
		 data-aos-mirror="false"
		 data-aos-once="true"
		 data-aos-anchor-placement="top-bottom">Landing Page Design <span class="horizontal-redline"></span></h2>
		<p data-aos="fade-left"
		 offset="120"
		 data-aos-delay="50"
		 data-aos-duration="800"
		 data-aos-easing="ease"
		 data-aos-mirror="false"
		 data-aos-once="true"
		 data-aos-anchor-placement="top-bottom" class="sub-headline">No matter how great your ads are, if your landing page fails to resonate with your customers and establish your brand’s trustworthiness, visitors will leave. Period. We help you: </p>
		<div data-aos="fade-left"
		 offset="120"
		 data-aos-delay="50"
		 data-aos-duration="800"
		 data-aos-easing="ease"
		 data-aos-mirror="false"
		 data-aos-once="true"
		 data-aos-anchor-placement="top-bottom" class="details-section">
			<img src="/images/design-icon.svg">
			<h3>Design</h3>
			<p>Create stunningly beautiful design for your landing page.  </p>
		</div>
		<div data-aos="fade-left"
		 offset="120"
		 data-aos-delay="0"
		 data-aos-duration="800"
		 data-aos-easing="ease"
		 data-aos-mirror="false"
		 data-aos-once="true"
		 data-aos-anchor-placement="top-bottom" class="details-section">
			<img src="/images/launch.svg">
			<h3>Deploy</h3>
			<p>Code, launch and maintain your landing page.</p>
		</div>
		<div data-aos="fade-left"
		 offset="120"
		 data-aos-delay="50"
		 data-aos-duration="800"
		 data-aos-easing="ease"
		 data-aos-mirror="false"
		 data-aos-once="true"
		 data-aos-anchor-placement="top-bottom" class="details-section">
			<img src="/images/optimize.svg">
			<h3>Optimize</h3>
			<p>Continuously improve the UX to maintain an optimal Conversion Rate.</p>
		</div>
		 <kinesis-container
            event="move" class="side-visual background-frame drop-shadow">
			  <kinesis-element 
							   tag="img"
							   :strength="20"
							   type="depth"
							   src="/images/design.svg"
							   />
		 </kinesis-container>
		 <kinesis-container
            event="scroll" class="glowing-circle-parent">
			  <kinesis-element 
							   tag="img"
							   class="glowing-circle"
							   :strength="500"
							   type="translate"
							    axis="y"
							    src="/images/glowing-circle.svg"
							   />
		  </kinesis-container>
	</div>
	<div class="paid-media">
		  <h2 data-aos="fade-up"
		   offset="120"
		   data-aos-delay="50"
		   data-aos-duration="500"
		   data-aos-easing="ease"
		   data-aos-mirror="false"
		   data-aos-once="true"
		   data-aos-anchor-placement="top-bottom">
			  <span class="horizontal-redline"></span>
			  <br>
			  Paid Media
		  </h2>
		  <div data-aos="fade-up"
		   offset="120"
		   data-aos-delay="50"
		   data-aos-duration="500"
		   data-aos-easing="ease"
		   data-aos-mirror="false"
		   data-aos-once="true"
		   data-aos-anchor-placement="top-bottom" class="sub-headline">
			  <p>
				  This is the age of paid media saturation. Conformity won’t take you anywhere. Stand out, scream loud. Blow the roof off! Here’s how we can help:
			  </p>
		  </div>
		  <div data-aos="fade-up"
		   offset="120"
		   data-aos-delay="50"
		   data-aos-duration="500"
		   data-aos-easing="ease"
		   data-aos-mirror="false"
		   data-aos-once="true"
		   data-aos-anchor-placement="top-bottom" class="details-section">
			  <img src="/images/instigate.svg">
			  <h3>Instigate</h3>
			  <p>Write copy that stirs your customers to action.</p>
		  </div>
		  <div data-aos="fade-up"
		   offset="120"
		   data-aos-delay="50"
		   data-aos-duration="500"
		   data-aos-easing="ease"
		   data-aos-mirror="false"
		   data-aos-once="true"
		   data-aos-anchor-placement="top-bottom" class="details-section">
			  <img src="/images/wow.svg">
			  <h3>Wow</h3>
			  <p>Create visuals that are hard to scroll by or swipe off.</p>
		  </div>
		  <div data-aos="fade-up"
		   offset="120"
		   data-aos-delay="50"
		   data-aos-duration="500"
		   data-aos-easing="ease"
		   data-aos-mirror="false"
		   data-aos-once="true"
		   data-aos-anchor-placement="top-bottom" class="details-section">
			  <img src="/images/manage.svg">
			  <h3>Manage</h3>
			  <p>Track and optimize your ad spend to give you the biggest bang for the buck. </p>
		  </div>
		  <kinesis-container
            event="move" class="center-visual background-frame drop-shadow">
			  <kinesis-element 
							   tag="img"
							   :strength="20"
							   type="depth"
							   src="/images/paid-media.svg"
							   />
		  </kinesis-container>
		  <kinesis-container
            event="scroll" class="glowing-circle-parent">
			  <kinesis-element 
							   tag="img"
							   class="glowing-circle"
							   :strength="500"
							   type="translate"
							    axis="y"
							    src="/images/glowing-circle.svg"
							   />
		  </kinesis-container>
	</div>
	<div id="work" class="our-work">
		<h2>Our Work <br> <span class="horizontal-redline"></span></h2>
		<div class="work-cards" id="work-cards">
			<img class="left-img" src="/images/gradient-dark-left.svg">
			<img class="right-img" src="/images/gradient-dark-right.svg">
			<div onclick="location.href='https://www.creativecareernow.com/';" class="card drop-shadow creative">
				<p class="small-text">Inhouse Project</p>
				<h3><span>Creative Career Now</span> A platform connecting art schools with students.</h3>
				<div class="side-bar-p">
					<div class="red-bar"></div>
					<p>We designed, built and launched Creative Career Now using Nuxt JS powered by a custom CMS. </p>
				</div>
				<div class="button">
					<a>VIEW PROJECT</a>
				</div>
			</div>
			<div onclick="location.href='https://techgenius.ca/';"  class="card drop-shadow techgenius">
				<p class="small-text">Client Project</p>
				<h3><span>TechGenius</span> A refreshingly new website for a local business.</h3>
				<div class="side-bar-p">
					<div class="red-bar"></div>
					<p>We built TechGenius’s new site on WordPress and helped them with content migration.</p>
				</div>
				<div class="button">
					<a>VIEW PROJECT</a>
				</div>
			</div>
			<div onclick="location.href='https://delivergrocery.ca/';" class="card drop-shadow deliver">
				<p class="small-text">Client Project</p>
				<h3><span>Deliver Grocery</span> A hyper-local grocery delivery service in Canada.</h3>
				<div class="side-bar-p">
					<div class="red-bar"></div>
					<p>We helped a startup launch their website in just two weeks during the COVID pandemic. </p>
				</div>
				<div class="button">
					<a>VIEW PROJECT</a>
				</div>
			</div>
				<div onclick="location.href='https://helpmebuy.io/';"  class="card drop-shadow helpmebuy">
				<p class="small-text">Inhouse Project</p>
				<h3><span>Help Me Buy</span> Empowering you to make smarter sales decisions.</h3>
				<div class="side-bar-p">
					<div class="red-bar"></div>
					<p>We launched a one of a kind review website that’s built entirely on Google’s AMP framework.</p>
				</div>
				<div class="button">
					<a>VIEW PROJECT</a>
				</div>
			</div>
		</div>
		<img v-on:click="leftArrow" class="left-arrow arrow" src="/images/left-arrow.svg">
	    <img  v-on:click="rightArrow"  class="right-arrow arrow" src="/images/right-arrow.svg">
	</div>
	<div class="testimonials">
		<div data-aos="fade-right"
		 data-aos-duration="800"
		 data-aos-easing="ease"
		 data-aos-mirror="false"
		 data-aos-once="true"
		 data-aos-anchor-placement="top-bottom"  class="testimonial">
			<div class="testimonial-content">
				<h4>We use Super Awesome Lab for lead generation; they've helped us <span>consistently achieve our marketing targets.</span></h4>
				<p>Carrie Li</p>
				<p>Toronto Film School</p>
			</div>
			<div class="testimonial-pic">
				<img src="/images/testimonial-01.png">
			</div>
		</div>
	    <div data-aos="fade-left"
		 data-aos-duration="800"
		 data-aos-easing="ease"
		 data-aos-mirror="false"
		 data-aos-once="true"
		 data-aos-anchor-placement="top-bottom"  class="testimonial">
			<div class="testimonial-content">
				<h4>We approached Super Awesome Lab for a new landing page and we are <span>more than happy</span> with how everything turned out.</h4>
				<p>Praveen Victor</p>
				<p>Deliver Grocery</p>
			</div>
			<div class="testimonial-pic">
				<img src="/images/testimonial-02.png">
			</div>
		</div>
	</div>
	<div id="values" class="mission">
			<kinesis-container
            event="scroll" class="glowing-circle-parent">
			  <kinesis-element 
							   tag="img"
							   class="glowing-circle"
							   :strength="500"
							   type="translate"
							    axis="y"
							    src="/images/glowing-circle.svg"
							   />
		  </kinesis-container>
		<p>
			Like you, <span>we are passionate about our craft</span>. We are not looking for a ripple or a splash, we want to start a <span>tsunami</span>. Here are our core values:
		</p>
	</div>
	<div class="values">
		<div class="value">
			<img src="/images/caution.svg">
			<p><span>Creativity over caution:</span> Carefulness and mediocrity are better to have as enemies than friends.</p>
		</div>
		<div class="value">
			<img src="/images/idea.svg">
			<p><span>Big idea saves the day:</span> You can get away with a  good idea & bad execution but not the other way around.</p>
		</div>
		<div class="value">
			<img src="/images/copy.svg">
			<p><span>Copy always comes first:</span> Everything starts with the written word.</p>
		</div>
		<div class="value">
			<img src="/images/respect.svg">
			<p><span>Respect your customers:</span> Treating your customers like dumb, driven cattle is a cardinal sin.</p>
		</div>
		<div class="value">
			<img src="/images/cause.svg">
			<p><span>Fight the good fight:</span> Everything you do, do it for a cause that’s bigger than yourself.</p>
		</div>
		<div class="value">
			<img src="/images/meet.svg">
			<p><span>Just show up:</span> Put aside all your biases, meet your customers where they are.</p>
		</div>
	</div>
	<div class="contact-us">
		<h2>Let's Chat!<br> <span class="horizontal-redline"></span></h2>
		<p>Please click on the button and fill out the form to get in touch. If you prefer email, shoot us a message at <i>hey@superawesomelab.com</i></p>
		<a class="cta" href="https://super-awesome-lab.typeform.com/to/PK98i81C">Let's Talk</a>
		<div data-aos="fade-left"
			 offset="120"
			 data-aos-delay="250"
			 data-aos-duration="800"
			 data-aos-easing="ease"
			 data-aos-mirror="false"
			 data-aos-once="true"
			 data-aos-anchor-placement="top-bottom"
			 class="phone-img"></div>
	</div>
	<div class="footer"></div>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'	

export default {
  name: 'HomePage',
  props: {
    msg: String
  },
	components: {
		Slide 
	},
	data: function () {
		return {
		}
	},
	methods: {
	  leftArrow: function (event) {
		  document.getElementById('work-cards').scrollLeft -= 50;
	  },
	   rightArrow: function (event) {
		  document.getElementById('work-cards').scrollLeft += 50;
	  }
  },
	mounted: function(){ 
		AOS.init({
			disable: function() {
				var maxWidth = 800;
				return window.innerWidth < maxWidth;
			}
		});
		var elem = document.querySelector('#video-element');
		var rocket = document.getElementById("rocket-video");
		var logViewport = function () {
			if(rocket){
				var bounding = elem.getBoundingClientRect();
				var percentage = (bounding.top-bounding.height)/(bounding.height*2);
				//percentage = parseFloat(percentage).toFixed(2);
				if(bounding.top<bounding.height && Math.abs(percentage) < 1) {
					//console.log(Math.abs(percentage));
					rocket.currentTime = (rocket.duration*Math.abs(percentage)).toFixed(1);
					console.log(rocket.currentTime);
				}
			}
		};
		window.onscroll = function(){
			if(rocket){
				rocket.currentTime = (window.pageYOffset/400).toFixed(2);
			console.log(rocket.currentTime);
			}
		};
		if (window.matchMedia("(min-width: 768px)").matches) {
			let mousePosX = 0,
				mousePosY = 0,
				mouseCircle = document.getElementById("mouse-circle");
			document.onmousemove = (e) => {
				mousePosX = e.pageX;
				mousePosY = e.pageY;
			};
			let delay = 6,
				revisedMousePosX = 0,
				revisedMousePosY = 0;
			function delayMouseFollow() {
				requestAnimationFrame(delayMouseFollow);
				revisedMousePosX += (mousePosX - revisedMousePosX) / delay;
				revisedMousePosY += (mousePosY - revisedMousePosY) / delay;
				mouseCircle.style.top = revisedMousePosY + "px";
				mouseCircle.style.left = revisedMousePosX + "px";
			}
			delayMouseFollow();
		}

	}/*,
	metaInfo() {
        return { 
            title: "Super Awesome Lab - A Full Service Marketing Agency",
            meta: [
                { name: 'description', content:  'We are a full service marketing agency. We help you capture your brand’s full potential and engineer your revenue growth.'},
                { property: 'og:title', content: "Super Awesome Lab - A Full Service Marketing Agency"},
                { property: 'og:site_name', content: 'Super Awesome Lab'},
                {property: 'og:type', content: 'website'},
				{ property: 'og:site_name', content: 'Super Awesome Lab'},
                {property: 'og:image', content: 'https://storage.googleapis.com/super-awesome-lab-imgs/meta-img-02.jpg'}
            ]
        }
    }*/
}
</script>

